/**
 * Dimensiones A4 para vista previa / PDF.
 * Siempre en CSS px a 96 DPI lógico (independiente del DPI/escala de Windows).
 */
export const CONTRATO_A4 = {
  anchoMm: 210,
  altoMm: 297,
  paddingMm: { top: 18, right: 20, bottom: 20, left: 20 },
  /** CSS px por pulgada: fijo a propósito para que todas las PCs midan igual. */
  cssDpi: 96,
};

export function mmToPx(mm, dpi = CONTRATO_A4.cssDpi) {
  return Math.round((mm * dpi) / 25.4);
}

export function obtenerMedidasPaginaContrato() {
  const { anchoMm, altoMm, paddingMm } = CONTRATO_A4;
  const anchoPx = mmToPx(anchoMm);
  const altoPx = mmToPx(altoMm);
  const paddingTopPx = mmToPx(paddingMm.top);
  const paddingBottomPx = mmToPx(paddingMm.bottom);
  const paddingLeftPx = mmToPx(paddingMm.left);
  const paddingRightPx = mmToPx(paddingMm.right);
  const anchoContenidoPx = anchoPx - paddingLeftPx - paddingRightPx;
  const altoContenidoPx = altoPx - paddingTopPx - paddingBottomPx;

  return {
    anchoPx,
    altoPx,
    paddingTopPx,
    paddingBottomPx,
    paddingLeftPx,
    paddingRightPx,
    anchoContenidoPx,
    altoContenidoPx,
  };
}
